import React from 'react';

import styles from './Privacy.module.scss';
import { useTranslate } from 'react-polyglot';
import { Container, Row, Col } from 'react-bootstrap';
import Card from '../../Shared/Card/Card';

function Privacy(props: PrivacyProps) {
    const t = useTranslate();

    function fixNewLines(text: string) {
        return text.replace(/\n/g, '<br/>');
    }

    return (
        <div className="maincontent">
            <div className={styles.privacy}>
                <h1>{t("privacy.title")}</h1>
                <hr/>
                <Container className={styles.container}>
                    <Row className={styles.row}>
                        <Col 
                            sm="12"
                            md="12"
                            lg="12"
                            xl="12"
                            xxl="12"
                            className={styles.col}
                        >
                            <Card>
                                <h2>{t("privacy.gdpr.title")}</h2>
                                <p dangerouslySetInnerHTML={{__html: fixNewLines(t("privacy.gdpr.description"))}}></p>
                            </Card>
                        </Col>
                    </Row>
                    <Row className={styles.row}>
                        <Col 
                            sm="12"
                            md="12"
                            lg="6"
                            xl="6"
                            xxl="6"
                            className={styles.col}
                        >
                            <Card>
                                <h2>{t("privacy.personalinfo.title")}</h2>
                                <p dangerouslySetInnerHTML={{__html: fixNewLines(t("privacy.personalinfo.description"))}}></p>
                            </Card>
                        </Col>
                        <Col 
                            sm="12"
                            md="12"
                            lg="6"
                            xl="6"
                            xxl="6"
                            className={styles.col}
                        >
                            <Card>
                                <h2>{t("privacy.dogregistrations.title")}</h2>
                                <p dangerouslySetInnerHTML={{__html: fixNewLines(t("privacy.dogregistrations.description"))}}></p>
                            </Card>
                        </Col>
                        <Col 
                            sm="12"
                            md="12"
                            lg="6"
                            xl="6"
                            xxl="6"
                            className={styles.col}
                        >
                            <Card>
                                <h2>{t("privacy.data_collection.title")}</h2>
                                <p dangerouslySetInnerHTML={{__html: fixNewLines(t("privacy.data_collection.description"))}}></p>
                            </Card>
                        </Col>
                        <Col 
                            sm="12"
                            md="12"
                            lg="6"
                            xl="6"
                            xxl="6"
                            className={styles.col}
                        >
                            <Card>
                                <h2>{t("privacy.your_rights.title")}</h2>
                                <p dangerouslySetInnerHTML={{__html: fixNewLines(t("privacy.your_rights.description"))}}></p>
                            </Card>
                        </Col>
                        <Col 
                            sm="12"
                            md="12"
                            lg="6"
                            xl="6"
                            xxl="6"
                            className={styles.col}
                        >
                            <Card>
                                <h2>{t("privacy.transfer.title")}</h2>
                                <p dangerouslySetInnerHTML={{__html: fixNewLines(t("privacy.transfer.description"))}}></p>
                            </Card>
                        </Col>
                        <Col 
                            sm="12"
                            md="12"
                            lg="6"
                            xl="6"
                            xxl="6"
                            className={styles.col}
                        >
                            <Card>
                                <h2>{t("privacy.thirdparties.title")}</h2>
                                <p dangerouslySetInnerHTML={{__html: fixNewLines(t("privacy.thirdparties.description"))}}></p>
                            </Card>
                        </Col>
                        <Col 
                            sm="12"
                            md="12"
                            lg="6"
                            xl="6"
                            xxl="6"
                            className={styles.col}
                        >
                            <Card>
                                <h2>{t("privacy.dataprotection.title")}</h2>
                                <p dangerouslySetInnerHTML={{__html: fixNewLines(t("privacy.dataprotection.description"))}}></p>
                            </Card>
                        </Col>
                        <Col 
                            sm="12"
                            md="12"
                            lg="6"
                            xl="6"
                            xxl="6"
                            className={styles.col}
                        >
                            <Card>
                                <h2>{t("privacy.protesting.title")}</h2>
                                <p dangerouslySetInnerHTML={{__html: fixNewLines(t("privacy.protesting.description"))}}></p>
                            </Card>
                        </Col>
                    </Row>
                    <Row className={styles.row}>
                        <Col 
                            sm="12"
                            md="12"
                            lg="12"
                            xl="12"
                            xxl="12"
                            className={styles.col}
                        >
                            <Card>
                                <h2>{t("privacy.contact.title")}</h2>
                                <p dangerouslySetInnerHTML={{__html: fixNewLines(t("privacy.contact.description"))}}></p>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
}

class PrivacyProps {
    
}

export default Privacy;
